import {JobAppointmentEventDataApiDto, JobEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {getAppointment} from "../../../store/view/appointment";
import AppointmentStatus from "../../appointment/AppointmentStatus";
import JobEvent, {JobEventTypeEnum} from "./JobEvent";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import DateUtils from "../../../utils/DateUtils";
import moment = require("moment");

/**
 * Job appointment event.
 */
export default class JobAppointmentEvent extends JobEvent {
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobAppointmentEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobEvent {
		const type = json.type == JobEventTypeEnum.AppointmentCreated ? JobEventTypeEnum.AppointmentCreated :
			JobEventTypeEnum.AppointmentUpdated;
		const entity = AuthenticatedEntity.fromJson(json.entity);
		const data = JobAppointmentEventData.fromJson(json.data as JobAppointmentEventDataApiDto);
		return new JobAppointmentEvent(json.id, json.jobId.toString(), type, entity, moment(json.createdAt),
			json.referenceNumber, data);
	}

	statusDisplayText() {
		return this.data.status.label;
	}

	newStatusDisplayText() {
		return this.data.status.label;
	}

	getIcon() {
		return Icon.Appointments;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getActivityType(): string {
		return `APPOINTMENT`;
	}

	getActivityMessage(): string {
		return `Scheduled for ${this.data.appointmentDate.format(DateUtils.DATE_TIME_FORMAT)}`
	}
}

export class JobAppointmentEventData {
	constructor(public readonly id: string,
		public readonly appointmentDate: moment.Moment,
		public readonly status: AppointmentStatus) {}

	public static fromJson(json: JobAppointmentEventDataApiDto): JobAppointmentEventData {
		return new JobAppointmentEventData(json.id, moment(json.date), AppointmentStatus.fromString(json.status));
	}

	public getAppointment(leadId: string) {
		return getAppointment(leadId, this.id)
	}
}